<template>
    <div>
        <el-button v-on:click="backHistory">返回</el-button>
        <div class="shezhi" style="margin-top:1%;" ><span class="spana">基本设置:</span></div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">广告类型:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-radio v-model="query.resource_type" :label="3">文章</el-radio>
                <el-radio v-model="query.resource_type" :label="4">视频</el-radio>
                <el-radio v-model="query.resource_type" :label="5">banner</el-radio>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">广告名称:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-input v-model="query.ad_name" placeholder="请输入内容" style="width:30%;" ></el-input>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">广告标题:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-input v-model="query.title" placeholder="请输入内容" style="width:30%;" ></el-input>
            </div>
        </div>
        <div class="infoDetailBoxs" style="height:140px;">
            <div style="width: 10%;float:left;height:20px;line-height: 50px;text-align: right;">
                <span class="spana">摘要:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    v-model="query.content">
                </el-input>
                <!-- <el-input v-model="query.type" placeholder="请输入内容" style="width:30%;" ></el-input> -->
            </div>
        </div>
        <div class="infoDetailBoxs" style="height: 267px;">
            <div style="width: 10%;float:left;height:100px;line-height: 36px;text-align: right;">
                <span class="spana">标题图片:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="float:left;width: 220px; height: 199px;">
                 <el-upload
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                    <el-input v-model="query.title_photo" style="display: none" clearable ></el-input>

                    <img v-if="query.title_photo" :src="query.title_photo" class="avatar" style="float:left;width: 220px; height: 199px;">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <!-- <el-input v-model="query.title_photo" placeholder="请输入内容" style="width:30%;" ></el-input> -->
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">内容页链接:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-input v-model="query.url" placeholder="请输入内容" style="width:30%;" ></el-input>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">视频链接:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-input v-model="query.tv_url" placeholder="请输入内容" style="width:30%;" ></el-input>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">投放开始时间:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-date-picker
                v-model="query.send_time"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
                </el-date-picker>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">投放截止时间:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-date-picker
                v-model="query.send_end_time"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
                </el-date-picker>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">优先级:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <template>
                    <el-select v-model="query.ad_priority" placeholder="请选择">
                        <el-option
                        v-for="item in priority"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">位置:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <template>
                    <el-select v-model="query.ad_position" placeholder="请选择">
                        <el-option
                        v-for="item in position"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </template>
            </div>
        </div>
                <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">直达原文页:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-radio v-model="query.is_original" :label="1">是</el-radio>
                <el-radio v-model="query.is_original" :label="2">否</el-radio>
            </div>
        </div>
        <div class="infoDetailBoxs">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">显示观点:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-radio v-model="query.is_comment" :label="1">是</el-radio>
                <el-radio v-model="query.is_comment" :label="2">否</el-radio>
            </div>
        </div>
        <div class="infoDetailBoxs" style="height:auto;">
            <div style="width: 10%;float:left;height:20px;line-height: 36px;text-align: right;">
                <span class="spana">标签:</span>&nbsp;&nbsp;&nbsp;
            </div>
            <div style="width：40px;float:left;">
                <el-input v-model="cate_name" placeholder="请输入内容" style="width:30%;" ></el-input>
                <el-button type="success" round style="margin-right:10px;" @click.native="cateAdd()">添加</el-button>
                <div>
                    <el-tag
                    style=" margin-right: 10px; margin-top: 10px;"
                        :key="tag"
                        v-for="tag in FinalTags"
                        closable
                        :disable-transitions="false"
                        @close="handleCloseTwo(tag)">
                        {{tag.cate_name}}
                    </el-tag>
                </div>
                <div style="background: #DEDEDE; height: auto; width: 354px;padding: 15px;margin-top: 10px;">
                    <el-tag
                        style="margin-right: 10px;margin-bottom: 10px;"
                        :key="'tag'+index"
                        v-for="(tag,index) in dynamicTags"
                        @click.native="catePush(tag)"
                        >
                        {{tag.cate_name}}
                        <!-- {{tag.cate_name}} -->
                        <!-- {{tag.cate_id}} -->
                    </el-tag>
                </div>
            </div>
        </div>
        <el-row class="button-row">
            <el-button type="info" round v-on:click="backHistory">取消</el-button>
            <el-button type="success" round style="margin-right:10px;" @click.native="onSubmit('add')">发布</el-button>
        </el-row>

    </div>
</template>

<script>
import { BASE_URL } from "../../config/app";
import Tinymce from "../../components/Tinymce/index.vue";
import { findCeate, findDetail, cateCommonlyList, createAdd } from "../../api/posting/posting";
// import { quillRedefine } from 'vue-quill-editor-upload' //引入图片上传
export default {
    data() {
        return {
            // uploadUrl: "http://tapi.inchengzi.com/upload",
            uploadUrl: BASE_URL+"/admin/app/Users/getUploadImage",
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            editorOption: {}, //富文本编辑器配置文件上传路径
            query: {
                ad_priority:'',
                find_id:'',
                resource_type: 3,
                title : '',
                social_title : '',
                url: '',
                content: '',
                send_time: '',
                send_end_time: '',
                title_photo: '',
                cover_photo: '',
                send_type: 2,
                is_original: 2,
                is_comment: 2,
                textarea: '',
                FinalTags: '',
                upd_type: '',
                tv_url: '',
                source: '广告'
            },
            list: [],
            value: '',
            videoFlag: false,
            //是否显示进度条
            videoUploadPercent: "",
            //进度条的进度，
            isShowUploadVideo: false,
            //显示上传按钮
            videoForm: {
                showVideoPath: '',
                videoName: ''
            },
            data: [{
                label: '一级 1',
                children: [{
                    label: '二级 1-1',
                }]
            }],
            gaoji:false,
            cateList: [],
            dynamicTags: [],
            inputVisible: false,
            inputValue: '',
            cate_name:'',
            FinalTags: [],  // 最终版tag选择
            upd_type: '',
            priority: [{
                value: '1',
                label: '1'
            }, {
                value: '2',
                label: '2'
            }, {
                value: '3',
                label: '3'
            }, {
                value: '4',
                label: '4'
            }, {
                value: '5',
                label: '5'
            }, {
                value: '6',
                label: '6'
            }, {
                value: '7',
                label: '7'
            }, {
                value: '8',
                label: '8'
            }, {
                value: '9',
                label: '9'
            }, {
                value: '10',
                label: '10'
            }],
            position: [{
                value: '1',
                label: '1'
            },{
                value: '2',
                label: '2'
            },{
                value: '3',
                label: '3'
            },{
                value: '4',
                label: '4'
            },{
                value: '5',
                label: '5'
            },{
                value: '6',
                label: '6'
            }, {
                value: '7',
                label: '7'
            }, {
                value: '8',
                label: '8'
            },{
                value: '9',
                label: '9'
            },{
                value: '10',
                label: '10'
            }, {
                value: '15',
                label: '15'
            }],
            home_max_count: 10,
        }
    },
    methods: {
        // 动态标签
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        handleCloseTwo(tag) {console.log(1111111111111);
            this.FinalTags.splice(this.FinalTags.indexOf(tag), 1);
        },
        showInput() {
            this.inputVisible = true;

            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            // this.cateCreate(inputValue);
            this.inputVisible = false;
            this.inputValue = '';
        },
	    //上传前回调 视频
        beforeUploadVideo(file) {
            var fileSize = file.size / 1024 / 1024 < 50;
            if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
                this.$message.error("请上传正确的视频格式");
                return false;
            }
            if (!fileSize) {
                this.$message.error("视频大小不能超过50MB");
                return false;
            }
            this.isShowUploadVideo = false;
        },
        //进度条 视频
        uploadVideoProcess(event, file, fileList) {
            this.videoFlag = true;
            this.videoUploadPercent = file.percentage.toFixed(0) * 1;
            console.log(this.videoUploadPercent,'this.videoUploadPercent'); // 进度条
        },
        //上传成功回调 视频
        handleVideoSuccess(res, file) {
            this.isShowUploadVideo = true;
            this.videoFlag = false;
            this.videoUploadPercent = 0;
            //前台上传地址
            //if (file.status == 'success' ) {
            //    this.videoForm.showVideoPath = file.url;
            //} else {
            //     layer.msg("上传失败，请重新上传");
            //}

            //后台上传地址s

            if (res.code == 0) {
                this.videoForm.showVideoPath = res.data.videoName;
                this.videoForm.videoName = res.data.name;
            } else {
                this.$message.error(res.Message);
            }
        },

        // 旧 图片
        handleAvatarSuccess(res, file) {
            this.query.title_photo = res.data;
            this.imageUrl = res.data
            this.query.title_photo = res.data;
        },
        handleAvatarSuccessTwo(res, file) {
            this.query.cover_photo = BASE_URL+'/'+res.data;
            this.imageUrl = BASE_URL+'/'+res.data
            this.query.cover_photo = BASE_URL+'/'+res.data;
        },
        beforeAvatarUpload(file) {
            let _this = this
            let file_type = file.type.substr( 0, file.type.indexOf("/"));
            if( !([ "image"]).includes( file_type)){
                this.$message.error( "只能上传图片");
                return false;
            }
            if( file_type == "image"){
                // const isLt2M = file.size / 1024 / 1024 < 2;
                const isSize = new Promise(function (resolve, reject) {
                    // let width = 198;
                    // let height = 198;
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function () {
                        // let valid = img.width == width && img.height == height;
                        let valid = true
                        valid ? resolve() : reject();
                    }
                    img.src = _URL.createObjectURL(file);
                }).then(res=>{
                    return file;
                }).catch(err=>{
                    this.$message.error('图片格式错误，请上传长198像素、宽198像素的图片');
                    return Promise.reject();
                });
                return isSize
            }
            this.uploading = true;
        },


        handleRemove(file, fileList) {
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.query.image = this.dialogImageUrl;
            this.dialogVisible = true;
        },
        backHistory(){
            this.$router.go(-1);//返回上一层
        },
        // getData() {
        //     openScreen(this.query)
        //         .then(response => {
        //             this.loading = false;
        //             this.options = response.data.data || [];
        //         })
        //         .catch(() => {
        //             this.loading = false;
        //             this.list = [];
        //             this.total = 0;
        //         });
        // },
        getList() {
           this.loading = true;
           var formDatas = {'find_id':this.query.find_id}
            findDetail(formDatas)
                .then(response => {
                    this.loading = false;
                    this.query = response.data || [];
                    this.query.resource_type = parseInt(this.query.resource_type)
                    this.FinalTags = response.data.cate || [];
                    // this.query.send_type=response.data.send_type;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        getCateList() {
           this.loading = true;
            cateCommonlyList()
                .then(response => {
                    this.loading = false;
                    this.dynamicTags = response.data
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        catePush(tag) {
            // console.log(this.FinalTags.length,'length');
            if( this.FinalTags.length >= this.home_max_count){
                this.$errMsg( "最多只能添加" + this.home_max_count + "个标签");
                return;
            }

            var cate_id = tag.cate_id;
            var cate_name = tag.cate_name;
            var cate = false;
            this.FinalTags.forEach( ( item) =>{
                cate = cate || item.cate_id == cate_id;
            });

            // 不重复加入
            if (cate ) {
                this.$errMsg( cate_name + "已设为标签");
                return;
            }

            // 原来添加
            if (tag) {
                this.FinalTags.push(tag);
            }
        },
        cateAdd() {
            if (this.cate_name == '') {
                this.$message.error( "tag名称为空");
                return false;
            }
            var formDatas = {'cate_name':this.cate_name}
            createAdd(formDatas)
                .then(response => {
                    if (response) {
                        this.cate_name = ''
                        if (this.FinalTags.length > 0 ) {
                            var bool = true
                            this.FinalTags.forEach((obj, index) => {
                                if (response.data.cate_id == obj.cate_id) {
                                    bool = false;
                                }
                            });
                            if(bool){
                                this.FinalTags.push(response.data);
                            }

                        } else {
                            this.FinalTags.push(response.data);
                        }
                    }
                    this.loading = false;
                    this.getCateList();
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        // 保存按钮
        onSubmit(upd_type) {
            this.query.FinalTags = this.FinalTags
            this.query.upd_type = this.upd_type ? this.upd_type : upd_type
            this.loading = true;

            if (this.query.title == '') {
                this.$message.error( "标题不能为空");
                return false;
            }
            if (this.query.content == '') {
                this.$message.error( "摘要不能为空");
                return false;
            }
            if (this.query.url == '') {
                this.$message.error( "原文链接不能为空");
                return false;
            }
            if (this.query.FinalTags == '') {
                this.$message.error( "所选标签不能为空");
                return false;
            }

            // 打印所有入库的值
            findCeate(this.query)
            .then(response => {
                if (response.code == 0) {
                    this.$message({
                        message: '操作成功！',
                        type: 'success'
                    });
                    this.$router.push({ path: `/advertList/advertList` })
                }
            })
            .catch(() => {
                this.loading = false;
                this.list = [];
                this.total = 0;
            });
        },
        shezhi() {
            this.gaoji = !this.gaoji;
        }
    },
    components: {
        Tinymce
    },
    computed: {
        editor() {
            return this.$refs.myQuillEditor.quill;
        },
        proStatus() { //上传状态
            if (this.pass) {
                return 'success'
            } else if (this.pass === false) {
                return 'exception'
            } else {
                return 'success'
            }
        },
    },
    created() {

        // 将参数拷贝进查询对象
        this.query.find_id = this.$route.params.find_id ?  this.$route.params.find_id : 0 ;
        if (this.query.find_id != 0 && this.query.find_id != null && this.query.find_id != "null") {
            this.upd_type = 'upd'
            this.getList();
        }
        this.getCateList();

        // this.editorOption = quillRedefine( //修改富文本编辑器图片上传路径
        // {
        //     // 图片上传的设置
        //     uploadConfig: {
        //         action: this.uploadUrl, // 必填参数 图片上传地址
        //         res: (respnse) => {
        //             return respnse.data; //return图片url
        //         },
        //         name: 'file' // 图片上传参数名
        //     }
        // })
    },
    filters: {
        //时间转换 用到moment.js
        formatDate: function(value) {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
        findTypeLabel(status) {
            const statusMap = {
                1: "患儿故事",
                2: "患儿视频",
                3: "学术动态",
            };
            return statusMap[status];
        }
    }
};
</script>

<style type="text/scss" lang="scss">
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
.spana {
    width: 40px;
}
div {
    font-size: 14px;
}
p {
    font-size: 14px;
}
>>>.el-row{
    margin-bottom: 12px;
}
.uploadProductDiv {
    width: 1190px;
    box-sizing: border-box;
    margin: 0 auto;
    background: #FFFFFF;
    border-radius: 4px;
}

.uploadProductDiv-header {
    text-align: center;
    font-size: 30px;
    color: #333333;
    letter-spacing: 0;
    font-weight: bold;
    width: 100%;
    height: 100px;
    line-height: 100px;
    background: #FBD7D9;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
}

.uploadProductDiv-body {
    box-sizing: border-box;
    padding-left: 115px;
    padding-top: 65px;
}

.uploadProductDiv-inputDiv {
    display: flex;
    margin-bottom: 20px;
    position: relative;
}

.uploadProduct-Pname {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    height: 40px;
    width: 140px;
}
.form-input{
    width: 440px;
}
.uploadProduct-input {
    box-sizing: border-box;
    width: 440px;
    height: 40px;
    line-height: 40px;
    background: #F3F0F0;
    border: 1px solid #DEDEDE;
    border-radius: 4px;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    padding-left: 20px;
    outline: none;
    margin-left: 46px;
    position: absolute;
    left: 62px;
}
.uploadProduct-pyuan {
    position: absolute;
    left: 565px;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    height: 40px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.button-row {
    margin-top: 20px;
    margin-left: 12%;
}
.inputs {
    border: #757779 1px solid;
    height: 40px;
    margin-left: 20px;
    width: 122px;
}
.infoDetailBoxTwo {
    height: 190px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid  #dddddd;
    position: relative;
    div {
        width: 72%;
    }
}
.infoDetailBoxs {
    height: 80px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid  #dddddd;
    position: relative;
    div {
        width: 56%;
    }
}
.infoDetailBoxContent {
    height: 480px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid  #dddddd;
    position: relative;
    div {
        width: 56%;
    }
}
.gcDetails {
    box-sizing: border-box;
    padding: 15px 50px;
    border-bottom: 1px solid #dddddd;
    > div {
        display: flex;
    }
}
.gcDetails > div > :nth-child(2) {
    margin-left: 50px;
}
.chakandetail {
    color: #2490fa;
    cursor: pointer;
    margin-left: 10px;
}
.jlSpan {
    margin-left: 35px;
}
.imgsDiv {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    width: 525px;
    img {
        margin-right: 10px;
        margin-bottom: 10px;
    }
}
.shezhi {
    width: 100%;
    background: lightgray;
    height: 50px;
    text-align: left;
    padding-left: 2%;
    font-size: large;
    line-height: 50px;
}
</style>
